let form = require('../actions/form');

module.exports = {
    /**
     * Введение текста в input
     * @type {*[]}
     */
    inputText: [
        form.inputText,
        form.validateUnsetError
    ],
    /**
     * Завершение ввода текста в инпут
     * @type {Array}
     */
    blurText: [
        form.trimText,
        form.validateText
    ],

    inputAndValidateText: [
        form.inputText,
        form.validateText
    ]
};



// WEBPACK FOOTER //
// ./signals/form.js